module.exports = __webpack_public_path__ + "img/api.0896f3c0.jpg";